import { render, staticRenderFns } from "./invoiceBreakdownWidget.vue?vue&type=template&id=5c534405&"
import script from "./invoiceBreakdownWidget.vue?vue&type=script&lang=js&"
export * from "./invoiceBreakdownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports